// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2k1dY","row":"ProcedureTreatmentSummary_row__2HHLh"};